module.exports = __webpack_public_path__ + "img/電気回路_2_5_1.5887bb31.png";